import React from 'react';
import { KText } from '@/component/RtlLayout';
import { k18nPro } from '../k18n/K18n';

export default function NewUser72Text(props?: { propsFontWeight?: string; propsColor?: string; propsFontSize?: number; marginTop?: boolean }) {
    return (
        <KText
            style={{
                color: props?.propsColor || '#000',
                fontSize: props?.propsFontSize || 14,
                fontWeight: (props?.propsFontWeight as any) || '400',
                lineHeight: 16,
                marginTop: props?.marginTop ? 6 : 0,
            }}>
            {k18nPro({
                text: '3个工作日不发货的{x}券',
                id: 'k_1257133',
                params: {
                    x: 'R$5',
                },
            })}
        </KText>
    );
}
